import { z } from 'zod';
import { listInputSchema, sortSchema } from './list';

/**
 * Contract for `users.list` — the workspace member directory.
 *
 * Deliberately filterless: a workspace has tens of members, not thousands, so
 * there is nothing to narrow down. The empty filter object keeps the endpoint on
 * the standard envelope (ADR-0001) so filters can be added later without a shape
 * change. Sorting and pagination are server-side, same as contacts.
 */
export const UsersListFilterSchema = z.object({});

/**
 * The one statement of which columns are sortable. Both the wire schema and the
 * table's header cells derive from it, so adding a sortable column is a one-line
 * change here that the URL codec and UI pick up for free.
 */
export const USERS_SORT_FIELDS = ['fullName', 'email', 'jobTitle', 'role', 'joinedAt'] as const;

export const UsersSortBySchema = z.enum(USERS_SORT_FIELDS);

export const UsersSortSchema = sortSchema(USERS_SORT_FIELDS, 'fullName', 'asc');

export const UsersListInputSchema = listInputSchema(UsersListFilterSchema, UsersSortSchema);

export type UsersSort = z.infer<typeof UsersSortSchema>;
export type UsersSortBy = UsersSort['by'];
export type UsersListInput = z.input<typeof UsersListInputSchema>;
/** Post-parse shape (schema defaults applied) — what the server actually acts on. */
export type UsersListQuery = z.output<typeof UsersListInputSchema>;

/** What the server applies when the client sends no `sort` — parsed, never hand-copied. */
export const USERS_SORT_DEFAULT: UsersSort = UsersSortSchema.parse(undefined);
